<template>
  <div class="match-item">
    <div class="match-wrap">
      <div class="match-date" v-html="getDateTimeString(match)" />
      <div class="match-series-wrap">
        <span class="match-num">{{
          match.event_name ? `${match.event_name}, ` : ""
        }}</span
        ><span class="match-series">{{ match.series_name }}</span>
      </div>
      <div class="match-data">
        <div class="team team-A">
          <span class="team-name">{{ match.teams[0].name }}</span
          ><span class="team-vs">{{ translations.vs_label }}</span
          ><span class="team-name team-B">{{ match.teams[1].name }}</span>
        </div>
      </div>
      <div class="match-more-info">
        <a
          v-if="!hideMatchTips"
          :href="getHref(CFG_MODULES.MATCH_INFO.route, match)"
          class="match-info"
        >
          {{ translations.match_info_label }}
        </a>
        <a
          :href="getHref(CFG_MODULES.LINEUP.route, match)"
          class="lineup-builder"
        >
          {{ translations.lineup_label }}
        </a>
        <a
          class="menu-card"
          :href="getHref(CFG_MODULES.GAME_PLAN.route, match)"
        >
          {{ translations.game_plan_label }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { getDateString, formatFullUrl } from "../../assets/js/common";
import { CFG_MODULES } from "../../assets/js/config";
export default {
  props: ["match", "translations", "hideMatchTips"],
  data() {
    return {
      CFG_MODULES,
    };
  },
  methods: {
    getDateTimeString(match) {
      return `${getDateString(match.start_date, "day")}<sup>${getDateString(
        match.start_date,
        "abb"
      )}</sup> 
      ${getDateString(match.start_date, "month")} 
      ${getDateString(match.start_date, "year")} | 
      ${getDateString(match.start_date, "time")}`;
    },
    getHref(parentRoute, match) {
      if (parentRoute === CFG_MODULES.LINEUP.route && !match.show_lineup) {
        return;
      } else if (parentRoute === CFG_MODULES.MATCH_INFO.route && !match.slug) {
        return;
      }
      return formatFullUrl(match, parentRoute);
    },
  },
};
</script>
